import { AddIcon } from "@chakra-ui/icons";
import { Button, Flex } from "@chakra-ui/react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import VideosTable from "../../components/tables/VideosTable";
import BasePage from "../common/BasePage";

export default function VideosPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goToCreateVideo = useCallback(() => {
    navigate("./create");
  }, [navigate]);

  return (
    <BasePage title={t("videos_page.videos")}>
      <Flex marginBottom="10" justifyContent="flex-end">
        <Button
          bg="primary.DEFAULT"
          color="white"
          leftIcon={<AddIcon />}
          onClick={goToCreateVideo}
        >
          {t("common.buttons.new")}
        </Button>
      </Flex>
      <VideosTable />
    </BasePage>
  );
}
